import React from 'react';
import { Grid, Typography, Box, ButtonGroup, Table, TableBody } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { StyledLink } from 'components/styles_components/link';
import { WhiteCard } from 'components/styles_components/card';
import { PlaceLink } from 'utils/link';
import ShowItemTableRow from 'components/item/show_item_table_row';
import InspectionSubject from 'utils/inspection_subject';
import EditButton from 'components/inspection_subject/button/edit';
import DeleteButton from 'components/inspection_subject/button/delete';
import GoogleLinkButton from 'components/navigation/google_link_button';
import FileSection from 'components/file/section';
import UploadInspectionSubjectFileMutation from 'mutations/external_file/upload_inspection_subject_file';

const ShowItem = ({ inspectionSubject, space, refetch }) => {
  const { place = {} } = inspectionSubject;

  return (
    <>
      <WhiteCard className={InspectionSubject(inspectionSubject).htmlClass}>
        <Typography variant="h5">{inspectionSubject.name}</Typography>
        <Grid container direction="row" justifyContent="space-between" spacing={2}>
          <Table sx={{ mt:2, mb: 2 }}>
            <TableBody>
              <ShowItemTableRow label={<FormattedMessage id="inspection_subject.serial_number" />}>
                {inspectionSubject.serialNumber || '-'}
              </ShowItemTableRow>
              <ShowItemTableRow label={<FormattedMessage id="inspection.overdue.count" />}>
                {inspectionSubject.overdueInspectionsTotal}
              </ShowItemTableRow>
              <ShowItemTableRow label={<FormattedMessage id="inspection.incoming.count" />}>
                {inspectionSubject.incomingInspectionsTotal}
              </ShowItemTableRow>
            </TableBody>
          </Table>
        </Grid>

        {space.adminRole && (
          <Grid size={{ xs: 12 }}>
            <Box display="flex" justifyContent="flex-end">
              <ButtonGroup variant="contained">
                <EditButton inspectionSubject={inspectionSubject} space={space} refetch={refetch} />
                <DeleteButton inspectionSubject={inspectionSubject} space={space} />
              </ButtonGroup>
            </Box>
          </Grid>
        )}
      </WhiteCard>

      <WhiteCard>
        <Typography variant="h5">
          <FormattedMessage id="place" />
        </Typography>
        <Table sx={{ mt:2, mb: 2 }}>
          <TableBody>
            <ShowItemTableRow label={<FormattedMessage id="place" />}>
              <StyledLink to={PlaceLink(place.id)}>{place.name}</StyledLink>
            </ShowItemTableRow>

            <ShowItemTableRow label={<FormattedMessage id="place.street" />}>{place.street}</ShowItemTableRow>
            <ShowItemTableRow label={<FormattedMessage id="place.zip_code" />}>{place.zipCode}</ShowItemTableRow>
            <ShowItemTableRow label={<FormattedMessage id="place.city" />}>{place.city}</ShowItemTableRow>
          </TableBody>
        </Table>
        <Box display="flex" justifyContent="flex-end">
          <ButtonGroup variant="contained">
            <GoogleLinkButton place={place} />
          </ButtonGroup>
        </Box>
      </WhiteCard>

      <FileSection
        files={inspectionSubject.externalFiles}
        uploadMutation={UploadInspectionSubjectFileMutation}
        uploadVariables={{ inspectionSubjectId: inspectionSubject.id }}
        refetch={refetch}
        canUpload={space.adminRole}
      />
    </>
  );
};

export default ShowItem;
